import { css } from '@emotion/css';

export const pageCx = css`
  display: flex;
  flex-direction: column;
`;

export const mainCx = css`
  &.with-header {
    padding-top: var(--header-height);
  }

  display: flex;
  flex-direction: column;
  position: relative;

  min-height: 100vh;
  flex: 1;
`;

export const titleBar = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.33;
  color: #ffffff;
  margin: 0;
`;

export const backButtonCx = css`
  margin-right: 16px;
  width: 15px;
  height: 100%;
  cursor: pointer;
`;

export const toolbar = css`
  width: 100%;
  background: var(--colors-primary-30);
  display: flex;
  align-items: center;
  padding: 16px;
`;
